import markdownit from 'markdown-it';
import { ReportAuthorConfig } from "../config/groupConfig";
import * as XLSX from "xlsx";

const markdownConverter = new markdownit({
  html: false,
  linkify: false,
});

class Utils {

  formatDate(date) {
    return new Date(date).toLocaleDateString("en-us", {
      weekday: "long",
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }
GetdayName(date) {
  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const dateinput= new Date(date);
  const dayIndex=dateinput.getDay();
  return dayNames[dayIndex];
}
getDateWithDayName(date) {
  const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const dateinput = new Date(date);
  const dayIndex = dateinput.getDay();
  return `${dayNames[dayIndex]} ${this.byodformatDate(date)}`;
}
  formatBytes(bytes, decimals = 2) {
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  getBytesInMB(bytes, decimals = 2) {
    const dm = decimals < 0 ? 0 : decimals;
    return parseFloat(bytes / 1024 ** 2).toFixed(dm);
  }
  getBytesFromGB(gbSize) {
    return gbSize * Math.pow(1024, 3);
  }
  getGBFromMB(fileSize, decimals) {
    const dm = decimals < 0 ? 0 : decimals;
    return parseFloat(fileSize / 1024).toFixed(dm);
  }

  getGBFormat(size) {
    return Number(size).toLocaleString('fullwide', {useGrouping:false});
  }
  getFileExtension(fileName) {
    var re = /(?:\.([^.]+))?$/;
    return re.exec(fileName)[1];
  }
  isContainSpecialCharacters(name) {
   // var regex = /[`!@#$%^&*()+\=\[\]{};':"\\|,<>\/?~]/;
   var regex = /[`!@#$%^*+\=\[\]{};':"\\|,<>\/?~]/;
    return regex.test(name);
  }

  //ddmmyyyhhmmss
  customformattedDate(date) {
  let datePart = [
    date.getDate(),
    date.getMonth() + 1
    // ,date.getFullYear()
  ].map((n, i) => n.toString().padStart(i === 2 ? 4 : 2, "0")).join("");
  let timePart = [
    date.getHours(),
    //date.getMinutes(),
    date.getSeconds()
  ].map((n, i) => n.toString().padStart(2, "0")).join("");
  return datePart + timePart;
}
// as per figma
byodformatDate(date) {
  const fDate = new Date(date);

  let hours = fDate.getHours();
  let minutes = fDate.getMinutes();
  let newformat = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours || 12;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  return `${("00" + hours).slice(-2)}:${(
    "00" + minutes
  ).slice(-2)} ${newformat}`;
}

 /**
   * Get the HTML equivalent to Markdown text
   * @param {*} markdownText - Markdown text
   * @returns HTML equivalent to Markdown text
   */
 markdownToHtml = (markdownText) => {
  let escapedMarkdownText = markdownText?.replaceAll(/\\/g, '\\\\').replaceAll(/_/g, '\\_').replaceAll(/\\n\\n/g, '\n');
  return markdownConverter.render(escapedMarkdownText || '');
}

  /**
   * Add custom tooltip to the HTML element
   * @param {htmlElement} htmlElement parameter an object of html element
   * @param {tooltTipText} tooltTipText parameter a text which should be displayed in tooltip area
   * @param {id} id parameter is id for a tooltip area
   */
  addCustomTooltip(htmlElement, tooltTipText, id, position = "top") {
    const tooltip = document.createElement("div");
    tooltip.id = `tooltip${id}`;
    tooltip.className =
      position === "top"
        ? "tooltip-bulleted-numbered-top"
        : "tooltip-bulleted-numbered-bottom";
    tooltip.textContent = tooltTipText;
    tooltip.style.display = "none";
    const leftValue = tooltTipText === "Bulleted list" ? 36 : 42.5;
    const positionValue = position === "top" ? 40 : -40;

    document.body.appendChild(tooltip);

    htmlElement.addEventListener("mouseenter", (e) => {
      const rect = htmlElement.getBoundingClientRect();
      tooltip.style.left = `${rect.left +
        window.scrollX +
        rect.width / 2 -
        tooltip.offsetWidth / 2 -
        leftValue
        }px`; // Center horizontally
      tooltip.style.top = `${rect.top + window.scrollY - tooltip.offsetHeight - positionValue
        }px`; // Position above the button
      tooltip.style.display = "flex";
      tooltip.style.marginTop = "-4px";
      tooltip.style.height = "34px";
    });

    htmlElement.addEventListener("mouseleave", () => {
      tooltip.style.display = "none";
    });
  }

isSupportedDocumentType(extention) {
   return ReportAuthorConfig.supportedDocumentTypeList.indexOf(extention) > -1;
}

  // Changing the name of the duplicate document
  renameDocumentIfDuplicate = (newDocumentName, existingDocuments) => {
    // Extract the base name and extension
    const fileParts = newDocumentName.split(".");
    const extension = fileParts.pop(); // Get the extension
    let baseName = fileParts.join("."); // Get the base name

    let copyNumber = 1;
    let updatedFileName = newDocumentName;

    // Check if a file with the same name exists
    while (existingDocuments.includes(updatedFileName)) {
      updatedFileName = `${baseName}_copy ${copyNumber}.${extension}`;
      copyNumber++;
    }

    return updatedFileName;
  };

    /**
  * Function to convert sheet to x-data-spreadsheet data
  * @param {*} wb 
  * @returns 
  */
  stox = (wb) => {
    let out = [];
    wb.SheetNames.forEach(function (name) {
      let o = { name: name, rows: {} };
      let ws = wb.Sheets[name];

      if (ws["!ref"]) {
        let range = XLSX.utils.decode_range(ws["!ref"]);
        // sheet_to_json will lost empty row and col at begin as default
        range.s = { r: 0, c: 0 };
        let aoa = XLSX.utils.sheet_to_json(ws, {
          raw: false,
          header: 1,
          range: range,
          defval: ""
        });

        aoa.forEach(function (r, i) {
          let cells = {};
          r.forEach(function (c, j) {
            cells[j] = { text: c };

            let cellRef = XLSX.utils.encode_cell({ r: i, c: j });

            if (ws[cellRef] != null && ws[cellRef].D != null) {
              cells[j].text = "=" + ws[cellRef].D;
            }
          });
          o.rows[i] = { cells: cells };
        });
      }

      o.merges = [];
      (ws["!merges"] || []).forEach(function (merge, i) {
        //Needed to support merged cells with empty content
        if (o.rows[merge.s.r] == null) {
          o.rows[merge.s.r] = { cells: {} };
        }
        if (o.rows[merge.s.r].cells[merge.s.c] == null) {
          o.rows[merge.s.r].cells[merge.s.c] = {};
        }

        o.rows[merge.s.r].cells[merge.s.c].merge = [
          merge.e.r - merge.s.r,
          merge.e.c - merge.s.c
        ];

        o.merges[i] = XLSX.utils.encode_range(merge);
      });

      out.push(o);
    });
    return out;
  };

}


export default Utils;
